import type { ItemLimits, Limit } from '@site-builder/store-sdk';

export interface AvailabilityInfo {
  hasLimit: boolean;
  availableAmount: number;
  maxAvailableAmount: number;
}

export const getAvailabilityInfo = (
  limits?: ItemLimits | null,
): AvailabilityInfo => {
  const hasLimit = !!(limits?.perUser || limits?.perItem);
  if (!hasLimit) {
    return {
      hasLimit: false,
      availableAmount: Infinity,
      maxAvailableAmount: Infinity,
    };
  }
  const minLimit = findMinAvailableLimit(limits);
  return {
    hasLimit: true,
    availableAmount: minLimit?.available ?? 0,
    maxAvailableAmount: minLimit?.total ?? 0,
  };
};

export const findMinAvailableLimit = (
  limits?: ItemLimits | null,
): Limit | null => {
  const availableItems: Limit[] = [];

  const perItemAvailable = limits?.perItem;
  if (perItemAvailable) {
    availableItems.push(perItemAvailable);
  }

  const perUserAvailable = limits?.perUser;
  if (perUserAvailable) {
    availableItems.push(perUserAvailable);
  }

  const filteredAvailableItems = availableItems.filter(
    (item) =>
      item.available > 0 || (item.available >= 0 && !!item.recurrentSchedule),
  );

  if (filteredAvailableItems.length === 0) {
    return null;
  }

  if (filteredAvailableItems.length === 1) {
    return filteredAvailableItems[0];
  }

  return filteredAvailableItems.sort((a, b) =>
    a.available > b.available ? 1 : -1,
  )[0];
};
